import React, { useState, useEffect, useCallback } from 'react';
import { Tabs, Toast } from 'antd-mobile';
import TypeSeries from '../TypeSeries';
import FilesSeries from '../FilesSeries';
import { fetchIndustries } from '../../services/services';
import { locale } from '../../config/config';
import { INDUSTRY_MAP, INDUSTRIES_WITH_HANDBOOK } from '../../App';

export default function Universal({ state, setState }) {
  const [activeIndustry, setActiveIndustry] = useState(
    state?.selectedIndustry || 'EnterpriseNetwork'
  );
  const [industries, setIndustries] = useState([]);

  const handleIndustryChange = useCallback(
    industry => {
      if (activeIndustry === industry) return;

      setActiveIndustry(industry);
      setState(prev => ({
        ...prev,
        selectedIndustry: industry,
        openType: null,
        selectedSeries: null,
        loading: true, // 添加加载状态
      }));

      // 使用 replace 而不是直接修改 localStorage
      const defaultPath = `/${industry}/CellularRouter300/IR302`;
      window.location.replace(`#${defaultPath}`);
    },
    [activeIndustry, setState]
  );

  // 加载行业列表
  useEffect(() => {
    const loadIndustries = async () => {
      try {
        const res = await fetchIndustries();
        if (res.status === 200) {
          // 使用 INDUSTRY_MAP 排序
          const sortedIndustries = Array(Object.keys(INDUSTRY_MAP).length).fill(null);

          res.result.forEach(item => {
            const index = INDUSTRY_MAP[item.id];
            if (index !== undefined) {
              sortedIndustries[index] = item;
            }
          });

          const filteredIndustries = sortedIndustries.filter(Boolean);

          // 保存行业ID数组
          localStorage.setItem('idArray', JSON.stringify(filteredIndustries.map(item => item.id)));
          setIndustries(filteredIndustries);
        } else {
          Toast.show({
            content: res.error,
            duration: 3000,
          });
        }
      } catch (error) {
        Toast.show({
          content: error.message,
          duration: 3000,
        });
      }
    };

    loadIndustries();
  }, []);

  // 同步外部状态变化
  useEffect(() => {
    if (state?.selectedIndustry && state.selectedIndustry !== activeIndustry) {
      setActiveIndustry(state.selectedIndustry);
    }
  }, [state?.selectedIndustry, activeIndustry]);

  return (
    <div>
      <div
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 1,
          backgroundColor: '#fff',
        }}
      >
        <Tabs
          activeKey={activeIndustry}
          style={{
            '--active-line-color': '#3eb044',
            '--active-title-color': '#333333',
            '--content-padding': '0',
            '--active-line-height': '1.026vw',
            '--title-font-size': '3.077vw',
          }}
          onChange={key => {
            handleIndustryChange(key);
          }}
        >
          {industries.map(item => {
            const isHandbookEnabled = INDUSTRIES_WITH_HANDBOOK.includes(item.id);

            return (
              <Tabs.Tab
                title={item.name?.[locale] || item.name?.en || item.id || ''}
                key={item.id}
              >
                <TypeSeries
                  activeTab={activeIndustry}
                  typeSeries={state?.typeSeries}
                  hasHandbook={isHandbookEnabled}
                  key={`${activeIndustry}-${isHandbookEnabled}`}
                />
              </Tabs.Tab>
            );
          })}
        </Tabs>
      </div>
      <FilesSeries />
    </div>
  );
}
